import { isES } from "@/constants/core";
import { AxiosError } from "@/http";
import { ToastProps } from "@/models/toast";
import { logError } from "@/utils/errors";
import { getFirebaseErrorText } from "@/utils/validations/firebase";
import { FirebaseError } from "firebase/app";
import { toast } from "sonner";

export const customToast = ({ title, status }: ToastProps) => {
  if (status === "success") {
    toast.success(title);
  } else if (status === "error") {
    toast.error(title);
  } else if (status === "warn") {
    toast.warning(title);
  } else if (status === "info") {
    toast.info(title);
  } else {
    toast(title);
  }
};

export const showToastError = (error: any, message?: string) => {
  logError(error);

  if (message != null && message !== undefined) {
    toast.error(message);
  } else if (error instanceof AxiosError) {
    const status = error.response?.status;
    const customMessage = !(status && status >= 400 && status < 500)
      ? isES
        ? "Hubo un error, intenta mas tarde."
        : "An error occurred, please try again later."
      : null;

    toast.error(customMessage ?? error.response?.data?.message ?? error.message);
  } else if (error instanceof FirebaseError) {
    toast.error(getFirebaseErrorText(error.code, error.message));
  } else {
    toast.error(
      error?.response?.data?.message ?? error?.message ?? JSON.stringify(error) ?? message
    );
  }
};

export const showToastSuccess = (title: string) => {
  toast.success(title);
};
export const showToastWarn = (title: string) => {
  toast.warning(title);
};
